module.exports = __webpack_public_path__ + "img/4e27f21e73a559278b5d7b37765ea3f0.60e856f8.png";